import React from 'react';
import ReactApexChart from 'react-apexcharts';

const MultiLayerRadialChart = () => {
    const [state, setState] = React.useState({
        // ✅ Data for each language (can be percentages or raw values)
        series: [270, 90, 80, 70],

        options: {
            chart: {
                height: 390,
                type: 'radialBar',
            },

            plotOptions: {
                radialBar: {
                    startAngle: 0,
                    endAngle: 270, // Creates a 3/4 circle arc
                    offsetY: 0,

                    hollow: {
                        margin: 5,
                        size: '30%',
                        background: 'transparent',
                    },

                    dataLabels: {
                        name: {
                            show: false, // Hide label inside the ring
                        },
                        value: {
                            show: false, // Hide value inside the ring
                        }
                    },
                    barLabels: {
                    enabled: true,
                    useSeriesColors: true,
                    offsetX: -8,
                    fontSize: '16px',
                    formatter: function(seriesName, opts) {
                      return opts.w.globals.series[opts.seriesIndex]
                    },
                  },
                  
                },
            },

            // ✅ Just language names (used in legend & arc labels)
            labels: ['Launguage', 'Language', 'Language', 'Language'],

            // ✅ Show values where the arc starts using tooltip-like behavior
            annotations: {
                points: [
                    {
                        x: '50%',
                        y: '50%',
                        marker: {
                            size: 0,
                        },
                        label: {
                            text: '',
                            offsetY: 0,
                        },
                    },
                ],
            },

            colors: ['#9bbce2', '#ac4290', '#cc6ea0', '#6d4dbf'],

            // ✅ Show only the language names in the legend (remove values)
            legend: {
                show: true,
                position: 'bottom',
                formatter: function (seriesName) {
                    return seriesName; // ⛔️ no value shown here
                },
            },

            tooltip: {
                enabled: true,
                y: {
                    formatter: (val) => `${val}%`, // Optional: show % on hover
                }
            },

            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            show: false,
                        },
                    },
                },
            ],
        },
    });

    return (
        <div>
            <div id="chart">
                <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="radialBar"
                    height={390}
                />
            </div>
        </div>
    );
};

export default MultiLayerRadialChart;
